import { FreeCashRemovalPopupVariant } from "@swiggy-private/cart-types";

export const POPUP_IMAGE = {
    id: "TOING%20DARE%202%20COMPARE/Non%20compressed%20error/2x/7xxx.svg",
    width: 24,
    height: 24,
};

export const POPUP_COPY_BY_VARIANT = {
    [FreeCashRemovalPopupVariant.ITEM_REMOVAL]: {
        title: "You'll lose free cash if you remove this item!",
        description: "Are you sure you want to remove?",
        secondaryButtonText: "Don't remove",
        primaryButtonText: "Remove",
    },
    [FreeCashRemovalPopupVariant.MENU_NAVIGATION]: {
        title: "Free cash will be removed if you exit now!",
        description: "Are you sure you want to exit?",
        secondaryButtonText: "Do not exit",
        primaryButtonText: "Yes, exit",
    },
};
